
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.54 8.26l-6.293-2.304a.047.047 0 00-.063.045v15.656c0 .003.002.005.004.005h5.583c.679 0 1.229-.567 1.229-1.265V8.922a.703.703 0 00-.46-.662zm-2.899 7.996a.189.189 0 01-.188.188h-1.128a.189.189 0 01-.188-.188v-1.128c0-.104.084-.188.188-.188h1.128c.104 0 .188.084.188.188v1.128zm0-3.009a.189.189 0 01-.188.188h-1.128a.189.189 0 01-.188-.188V12.12c0-.103.084-.188.188-.188h1.128c.104 0 .188.085.188.188v1.128zm-4.16-10.781a.22.22 0 00-.153-.212 1.222 1.222 0 00-.36-.054.697.697 0 00-.218.035L3.487 5.244a.702.702 0 00-.487.67v14.53a1.22 1.22 0 001.22 1.218h9.249c.01 0 .014-.007.014-.014V2.466h-.002zM7.934 16.242a.202.202 0 01-.202.202h-1.85a.202.202 0 01-.202-.202v-1.098c0-.113.091-.202.202-.202h1.85c.112 0 .202.092.202.202v1.098zm0-3.009a.202.202 0 01-.202.202h-1.85a.202.202 0 01-.202-.202v-1.098c0-.112.091-.202.202-.202h1.85c.112 0 .202.092.202.202v1.098zm0-3.008a.202.202 0 01-.202.202h-1.85a.202.202 0 01-.202-.202V9.127c0-.113.091-.202.202-.202h1.85c.112 0 .202.091.202.202v1.098zm3.572 6.017a.202.202 0 01-.202.202h-1.85a.202.202 0 01-.202-.202v-1.098c0-.113.092-.202.202-.202h1.85c.113 0 .202.092.202.202v1.098zm0-3.009a.202.202 0 01-.202.202h-1.85a.202.202 0 01-.202-.202v-1.098c0-.112.092-.202.202-.202h1.85c.113 0 .202.092.202.202v1.098zm0-3.008a.202.202 0 01-.202.202h-1.85a.202.202 0 01-.202-.202V9.127c0-.113.092-.202.202-.202h1.85c.113 0 .202.091.202.202v1.098z","fill":"#fff","fill-rule":"nonzero"}})])
          )
        }
      }
    